import { render } from "./App.vue?vue&type=template&id=61442daa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=61442daa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61442daa"

export default script